import React from 'react'

import { FileUploadResult } from './utils/openAIFileUpload'

export interface AttachedFile {
  file: File
  uploadState: 'pending' | 'uploading' | 'processing' | 'uploaded' | 'error'
  uploadResult?: FileUploadResult
  error?: string
  progress?: number // 0-100
}

type ChatContextType = {
  messageText: string
  setMessageText: (text: string) => void
  onKeyDown: (event: any) => void
  onSubmit: () => void
  onRetry?: () => void
  textInputEnabled: boolean
  sendButtonEnabled: boolean
  websocketAvailable: boolean
  voiceSessionActive: boolean
  isStreaming?: boolean
  isAwaitingResponse?: boolean
  shouldShowRetryBanner?: boolean
  placeholder: string
  inputRef: React.RefObject<HTMLInputElement>
  isInFujiTour?: boolean
  attachedFiles: AttachedFile[]
  attachedFilesActions: {
    add: (file: AttachedFile) => void
    remove: (index: number) => void
    update: (index: number, file: AttachedFile) => void
    clear: () => void
    set: (files: AttachedFile[]) => void
  }
  isDragActive?: boolean
}

const ChatContext = React.createContext<ChatContextType | undefined>(undefined)

export const useChatContext = () => {
  const context = React.useContext(ChatContext)
  if (context === undefined) {
    throw new Error('useChatContext must be used within a ChatProvider')
  }
  return context
}

export const ChatProvider = ChatContext.Provider

export default ChatContext
